import React from "react";
import { Container, Badge } from "react-bootstrap";
import { Helmet } from "react-helmet";
import AppNavbar from "../../../components/common/AppNavbar";

const WHOChildObesityGuidelines2026 = () => {
  return (
    <>
      {/* ══════════════════════════════════════════════
          SEO — HELMET
      ══════════════════════════════════════════════ */}
      <Helmet>
        {/* ── Core Meta ── */}
        <html lang="en" />
        <title>
          WHO's First Child Obesity Guidelines: No Drugs or Surgery Under 10,
          Lifestyle Care First – Bharat Abroad
        </title>
        <meta
          name="description"
          content="The World Health Organization has issued its first global guidelines on obesity in children and adolescents. No weight-loss drugs, surgery or devices for ages 0–9; cautious, conditional options for teens. What it says and what Indian families abroad should know."
        />
        <meta
          name="keywords"
          content="WHO child obesity guidelines 2026, childhood obesity, adolescent obesity, GLP-1 children, weight-loss drugs teenagers, bariatric surgery adolescents, WHO guidelines October 2026, Indian children obesity, health news Indians abroad, Bharat Abroad health"
        />
        <meta name="author" content="Bharat Abroad Editorial" />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta name="theme-color" content="#0b2e2a" />
        <link
          rel="canonical"
          href="https://www.bharatabroad.com/articles/who-child-obesity-guidelines-2026"
        />

        {/* ── Geo / Audience ── */}
        <meta name="geo.region" content="IN" />
        <meta name="geo.placename" content="India" />
        <meta
          name="audience"
          content="Indian families abroad, parents, NRI community, healthcare professionals"
        />

        {/* ── Open Graph ── */}
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="WHO's First Child Obesity Guidelines: No Drugs or Surgery Under 10, Lifestyle Care First – Bharat Abroad"
        />
        <meta
          property="og:description"
          content="WHO's first global guidelines on child and adolescent obesity put lifestyle support first and rule out drugs and surgery for under-10s. Full explainer for Indian families abroad."
        />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/articles/who-child-obesity-guidelines-2026"
        />
        <meta property="og:site_name" content="Bharat Abroad" />
        <meta property="og:locale" content="en_IN" />
        {/* TODO: replace with your own licensed image */}
        <meta
          property="og:image"
          content="https://www.bharatabroad.com/images/who-child-obesity-guidelines.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="WHO first global guidelines on child and adolescent obesity, October 2026"
        />
        <meta
          property="article:published_time"
          content="2026-10-09T16:10:00+05:30"
        />
        <meta
          property="article:modified_time"
          content="2026-10-09T16:10:00+05:30"
        />
        <meta
          property="article:author"
          content="https://www.bharatabroad.com/about"
        />
        <meta
          property="article:publisher"
          content="https://www.bharatabroad.com"
        />
        <meta property="article:section" content="Health" />
        <meta property="article:tag" content="WHO" />
        <meta property="article:tag" content="Childhood Obesity" />
        <meta property="article:tag" content="GLP-1" />
        <meta property="article:tag" content="Adolescent Health" />
        <meta property="article:tag" content="Parenting" />

        {/* ── Twitter Card ── */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@BharatAbroad" />
        <meta name="twitter:creator" content="@BharatAbroad" />
        <meta
          name="twitter:title"
          content="WHO's First Child Obesity Guidelines – Bharat Abroad"
        />
        <meta
          name="twitter:description"
          content="No weight-loss drugs, surgery or devices for children under 10, says WHO. Lifestyle support comes first; teens get conditional options."
        />
        <meta
          name="twitter:image"
          content="https://www.bharatabroad.com/images/who-child-obesity-guidelines.jpg"
        />
        <meta
          name="twitter:image:alt"
          content="WHO child obesity guidelines — Bharat Abroad"
        />

        {/* ── JSON-LD: NewsArticle ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": "WHO's First Child Obesity Guidelines: No Drugs or Surgery Under 10, Lifestyle Care First",
            "description": "The World Health Organization has released its first global guidelines on obesity in children and adolescents, recommending structured lifestyle support first and advising against weight-loss drugs, bariatric surgery and devices for children aged 0 to 9.",
            "image": {
              "@type": "ImageObject",
              "url": "https://www.bharatabroad.com/images/who-child-obesity-guidelines.jpg",
              "width": 1200,
              "height": 630
            },
            "datePublished": "2026-10-09T16:10:00+05:30",
            "dateModified": "2026-10-09T16:10:00+05:30",
            "author": {
              "@type": "Organization",
              "name": "Bharat Abroad Editorial",
              "url": "https://www.bharatabroad.com/about"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Bharat Abroad",
              "url": "https://www.bharatabroad.com"
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.bharatabroad.com/articles/who-child-obesity-guidelines-2026"
            },
            "articleSection": "Health",
            "keywords": "WHO, childhood obesity, adolescent obesity, GLP-1, bariatric surgery, guidelines",
            "wordCount": "1200",
            "timeRequired": "PT7M",
            "inLanguage": "en-IN",
            "about": [
              { "@type": "Organization", "name": "World Health Organization" },
              { "@type": "MedicalCondition", "name": "Obesity" },
              { "@type": "Thing", "name": "Childhood Health" }
            ],
            "audience": {
              "@type": "Audience",
              "audienceType": "Indian families and parents living abroad"
            }
          }
        `}</script>

        {/* ── JSON-LD: BreadcrumbList ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",   "item": "https://www.bharatabroad.com" },
              { "@type": "ListItem", "position": 2, "name": "Health", "item": "https://www.bharatabroad.com/health" },
              { "@type": "ListItem", "position": 3, "name": "WHO Child Obesity Guidelines", "item": "https://www.bharatabroad.com/articles/who-child-obesity-guidelines-2026" }
            ]
          }
        `}</script>

        {/* ── JSON-LD: FAQPage ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What are the WHO's new child obesity guidelines?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Released on 7 October 2026, they are the WHO's first global guidelines on managing obesity in children and adolescents. They strongly recommend structured dietary, physical activity and behavioural interventions as the foundation of care."
                }
              },
              {
                "@type": "Question",
                "name": "Does WHO recommend weight-loss drugs for children?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Not for children aged 0 to 9. For adolescents aged 10 to 19, approved medicines may be considered only after a supervised multimodal lifestyle programme has not achieved the desired results."
                }
              },
              {
                "@type": "Question",
                "name": "Does WHO recommend bariatric surgery for teenagers?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Only under strict conditions. WHO says bariatric surgery may be considered for adolescents with severe obesity, and it advises against surgery and weight-loss devices for ages 0 to 9."
                }
              },
              {
                "@type": "Question",
                "name": "How many children and adolescents are affected?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "WHO reports about 170 million children and adolescents aged 5 to 19 were living with obesity in 2024, and around 400 million were overweight, including those with obesity."
                }
              },
              {
                "@type": "Question",
                "name": "What should Indian parents abroad do?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Talk to your child's paediatrician or family doctor before making any changes. The guidelines emphasise healthy eating, physical activity, behaviour support and supportive family environments, with medication or surgery reserved for specific cases under medical supervision."
                }
              }
            ]
          }
        `}</script>

        {/* ── JSON-LD: WebSite ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Bharat Abroad",
            "url": "https://www.bharatabroad.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://www.bharatabroad.com/search?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          }
        `}</script>
      </Helmet>

      <AppNavbar />

      <div style={{ background: "#f4f7fb" }}>
        {/* ══════════════════════════════
            HERO SECTION
        ══════════════════════════════ */}
        <div
          style={{
            background: "linear-gradient(135deg, #0b2e2a, #10453f, #17635a)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="success" className="mb-3">
              🩺 Trending · Health · October 2026
            </Badge>
            <h1 className="fw-bold">
              WHO's First Child Obesity Guidelines: No Drugs or Surgery Under
              10, Lifestyle Care Comes First
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              As weight-loss drugs spread rapidly among younger patients, the
              World Health Organization has drawn clear lines: structured
              support for every child, strict limits on medicine and surgery,
              and no drugs or operations at all for children under 10.
            </p>
          </Container>
        </div>

        {/* ══════════════════════════════
            BODY
        ══════════════════════════════ */}
        <section>
          <div className="container py-5">
            <p>
              On 7 October 2026 the World Health Organization published its
              first global guidelines on how health systems and clinicians
              should manage obesity in children and adolescents. The timing is
              significant. A new generation of appetite-suppressing medicines,
              known as GLP-1 drugs, has transformed adult obesity care, and
              families and doctors have been asking whether the same tools
              belong in paediatric medicine.
            </p>
            <p>
              WHO's answer is cautious: the foundation of care is support for
              eating, activity and behaviour, and medicines or surgery play, at
              most, a limited and conditional role for older adolescents.
            </p>

            {/* ── Stat Cards ── */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                gap: "12px",
                margin: "24px 0",
              }}
            >
              {[
                {
                  label: "Published",
                  value: "7 Oct 2026",
                  delta: "WHO, first of its kind",
                },
                {
                  label: "Living with obesity",
                  value: "170M",
                  delta: "Ages 5–19, in 2024",
                },
                {
                  label: "Overweight (incl. obesity)",
                  value: "~400M",
                  delta: "Ages 5–19, in 2024",
                },
                {
                  label: "Drugs / surgery",
                  value: "Not for 0–9",
                  delta: "WHO recommendation",
                },
              ].map((s) => (
                <div
                  key={s.label}
                  style={{
                    background: "#fff",
                    border: "1px solid #dde2ea",
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      textTransform: "uppercase",
                      letterSpacing: "0.06em",
                      color: "#999",
                      marginBottom: "6px",
                      fontWeight: 600,
                    }}
                  >
                    {s.label}
                  </div>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: 700,
                      color: "#0b2e2a",
                      lineHeight: 1.2,
                    }}
                  >
                    {s.value}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#0d7a5f",
                      fontWeight: 600,
                      marginTop: "3px",
                    }}
                  >
                    {s.delta}
                  </div>
                </div>
              ))}
            </div>

            <hr />

            {/* ── Section 1 ── */}
            <h3>1. Lifestyle Support Is the Foundation</h3>

            <h4>A strong recommendation for structured care</h4>
            <p>
              WHO strongly recommends that children and adolescents with obesity
              receive structured support on diet, physical activity and
              behaviour change, delivered either one-to-one or as part of a
              multimodal programme. It describes this as "person-centred" care,
              meaning it should be tailored to the child and family rather than
              handed out as a one-size-fits-all plan.
            </p>

            <h4>Part of a life-course approach</h4>
            <p>
              The new guidance sits alongside WHO's recommendations for adults,
              forming a continuous approach to obesity care from childhood
              through adolescence to adulthood. WHO published separate guidance
              for children from 29 days to under 10 years and for adolescents.
            </p>

            {/* Callout */}
            <div
              style={{
                borderLeft: "4px solid #0b2e2a",
                background: "#eaf5f2",
                borderRadius: "0 8px 8px 0",
                padding: "14px 20px",
                margin: "20px 0",
                fontSize: "15px",
                color: "#333",
                lineHeight: 1.7,
              }}
            >
              <strong>
                WHO's nutrition director says the base of care is access to
                comprehensive support, not medicine or surgery
              </strong>{" "}
              — helping children eat well, move more and build habits that
              last.
            </div>

            <hr />

            {/* ── Section 2 ── */}
            <h3>2. Under 10: No Drugs, Surgery or Devices</h3>
            <p>
              The clearest line in the guidelines concerns younger children. WHO
              does not recommend pharmacological treatment, bariatric surgery
              or weight-loss devices for children aged 0 to 9. Part of the
              reason is a lack of evidence: although drug makers are running
              trials in children as young as six, WHO had little research to
              draw on when judging the safety and effectiveness of these
              medicines for under-10s.
            </p>
            <p>
              Because obesity is a long-term condition, specialists also stress
              that long-term effects need to be understood before such drugs are
              recommended for young children.
            </p>

            <hr />

            {/* ── Section 3 ── */}
            <h3>3. Ages 10 to 19: Conditional and Carefully Limited</h3>

            <h4>Medicines as a later step</h4>
            <p>
              For adolescents aged 10 to 19, approved medicines may be
              considered, but only when a supervised multimodal lifestyle
              programme has not achieved the desired results. Coverage also
              notes that the young person should be mentally and physically
              prepared for treatment.
            </p>

            <h4>Surgery for severe obesity only</h4>
            <p>
              Bariatric surgery may be considered under strict conditions for
              adolescents with severe obesity. WHO frames both medicines and
              surgery as conditional options rather than routine first-line
              treatment.
            </p>

            <h4>How this differs from US paediatric advice</h4>
            <p>
              The approach is more cautious than the 2023 guidance from the
              American Academy of Pediatrics, which advised that adolescents
              aged 12 and older with obesity should be offered access to
              appropriate medicines and that teens aged 13 and older with
              severe obesity should be referred for surgery. American
              paediatricians generally follow the AAP, so families may hear
              different advice depending on where they live.
            </p>

            <hr />

            {/* ── Section 4 ── */}
            <h3>4. Why Now: The GLP-1 Boom</h3>
            <p>
              The guidelines contrast with WHO's adult recommendations from
              December 2025, which said GLP-1 drugs such as those sold under
              brands like Ozempic and Mounjaro could be used to tackle obesity
              in adults. Since then, use among younger patients has been
              climbing in some countries, and research on the drugs in children
              is moving quickly. In September, Novo Nordisk reported that around
              two in five young children given Wegovy in a trial lost enough
              weight to no longer be classed as having obesity, in the first
              trial to test the drug in under-12s.
            </p>
            <p>
              WHO's position is that promising early results are not enough to
              recommend these treatments for young children yet.
            </p>

            <hr />

            {/* ── Section 5 — Timeline ── */}
            <h3>5. How We Got Here: A Timeline</h3>

            <h4>January 2023</h4>
            <p>
              The American Academy of Pediatrics issues guidance supporting
              earlier use of medicines and surgery for eligible adolescents.
            </p>

            <h4>December 2025</h4>
            <p>
              WHO issues adult obesity guidelines saying GLP-1 drugs can be used
              to treat obesity in adults.
            </p>

            <h4>September 2026</h4>
            <p>
              Novo Nordisk reports results from the first trial of Wegovy in
              children under 12.
            </p>

            <h4>7 October 2026</h4>
            <p>
              WHO releases its first global guidelines on child and adolescent
              obesity, ruling out drugs, surgery and devices for ages 0 to 9 and
              setting strict conditions for adolescents.
            </p>

            <hr />

            {/* ── Summary ── */}
            <h3>What This Means for Indian Families Abroad</h3>

            <p>
              This article is general information, not medical advice. A few
              points stand out for parents:
            </p>

            <ul>
              <li>
                Start with food, activity, sleep and family routines. WHO's
                message is that supportive environments and habits are the core
                of treatment at every age
              </li>
              <li>
                Talk to your paediatrician or family doctor before considering
                any medication or procedure, and be aware that guidance in your
                country may differ from WHO's, as in the US
              </li>
              <li>
                Researchers have long noted that people of South Asian origin
                can face higher metabolic risk at lower body weights, so ask
                your doctor how they assess risk for your child
              </li>
              <li>
                Look for programmes that involve the whole family, since WHO
                stresses comprehensive, person-centred support rather than
                focusing on the child alone
              </li>
              <li>
                Be wary of marketing or online sellers offering weight-loss
                drugs for children, especially under 10, where WHO says there
                is not enough evidence to recommend them
              </li>
            </ul>

            <p>
              The new guidelines do not close the debate on medicines in
              younger patients, but they set a clear starting point: support
              first, and drugs or surgery only in narrow circumstances for
              older adolescents under medical supervision.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default WHOChildObesityGuidelines2026;
